import { useCallback, useState } from 'react';

type Primitive = boolean | number | string;

type Args = {
  value?: Primitive | Primitive[] | null;
  isActive?: boolean;
};

export const useSelectQueryGate = ({ value, isActive }: Args) => {
  const [opened, setOpened] = useState(false);
  const [openedOnce, setOpenedOnce] = useState(false);
  const onOpenChange = useCallback((next: boolean) => {
    setOpened(next);
    if (next) setOpenedOnce(true);
  }, []);

  const resolvedActive =
    typeof isActive === 'boolean'
      ? isActive
      : Array.isArray(value)
        ? value.length > 0
        : value !== null && value !== undefined;

  return {
    opened,
    onOpenChange,
    isActive: resolvedActive,
    hasValue: resolvedActive,
    shouldFetchOptions: opened || openedOnce,
    shouldFetchValue: resolvedActive,
    shouldFetchAny: opened || openedOnce || resolvedActive,
  };
};
